<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__wrapper">
        <div class="footer__top">
          <router-link :to="{ name: 'home' }">
            <img src="@images/footerLogo.png" alt="logo">
          </router-link>
          <div class="footer__top-line"></div>
          <p class="footer__top-text">Marketing for All</p>
        </div>
        <div class="footer__main">
          <div class="footer__column not-center">
            <h6>Contacts:</h6>
            <p>București Sectorul 2, Calea MOȘILOR, Nr. 195, <br> UNIT 17, Bloc 1bis, Etaj 5, Romania</p>
            <a href="mailto:info@alcorinnovativeltd.com" class="footer__column-link">info@alcorinnovativeltd.com</a>
          </div>
          <div class="footer__main-right">
            <div class="footer__column">
              <h6>Links:</h6>
              <p class="footer__column-link" @click="scrollTo('services', 'home')">Services</p>
              <p class="footer__column-link" @click="scrollTo('about', 'home')">About us</p>
              <p class="footer__column-link" @click="scrollTo('partner', 'home')">Partner Up</p>
              <p class="footer__column-link" @click="scrollTo('benefits', 'home')">Benefits</p>
            </div>
            <div class="footer__column">
              <h6>Legal Documents:</h6>
              <router-link :to="{ name: 'terms' }" class="footer__column-link">Terms & Conditions</router-link>
              <router-link :to="{ name: 'policy' }" class="footer__column-link">Privacy Policy</router-link>
            </div>
          </div>
        </div>
        <div class="footer__bottom">
          <p>© {{ actualYear }} ALCOR INNOVATIVE LTD S.R.L.  Registration number: 50312041 </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import {scroll} from "@/core/helpers/scrollTo.js";
import {useRoute, useRouter} from "vue-router";
import {computed} from "vue";

;

const router = useRouter()
const route = useRoute()

const actualYear = computed(() => new Date().getFullYear());

const scrollTo = (id, routeName) => {
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({
      name: 'home'
    }).then(scroll(id, 300));
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #252641;
  padding-block: 50px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
  }

  &__top {
    display: flex;
    align-items: center;
    gap: 40px;

    &-line {
      width: 1px;
      height: 83px;
      background-color: #626381;
    }

    &-text {
      width: 150px;
      color: $white;
      font-size: 22px;
      font-weight: 600;
      letter-spacing: 0.88px;
    }
  }

  &__main {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    &-right {
      display: flex;
      align-items: flex-start;
      gap: 60px;
    }
  }

  &__column {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

    &.not-center {
      align-items: flex-start;
    }

    & h6 {
      color: #FFF;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.72px;
    }

    & p {
      color: #9898B4;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.56px;
    }

    &-link {
      cursor: pointer;
      transition: 0.2s;

      color: #9898B4;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.56px;

      @include hover {
        color: #5c5c6c;
      }
    }
  }

  &__bottom {
    margin-top: 30px;

    & p {
      color: #B2B3CF;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.72px;
    }
  }
}

@media (max-width: 750px) {
  .footer {
    &__main {
      flex-direction: column;
      align-items: center;
      gap: 30px;
    }

    &__column {
      &.not-center {
        align-items: center;
      }

      & p {
        text-align: center;
      }
    }
  }
}

@media (max-width: 550px) {
  .footer {
    &__top {
      flex-direction: column;

      &-line {
        width: 100%;
        height: 1px;
      }

      &-text {
        width: 100%;
        text-align: center;
      }
    }

    &__main {
      &-right {
        flex-direction: column;
        align-items: center;
        gap: 30px;
      }
    }

    &__bottom {
      & p {
        font-size: 14px;
      }
    }
  }
}
</style>